import { Link } from 'react-router';
import type { MediaKitPack } from '../../lib/api/operatorConsole';
import { PackArt } from './PackArt';
import { formatUsd } from './mediaKitFormat';

export function PackTile({ pack }: { pack: MediaKitPack }) {
  return (
    <Link
      to={`/media-kit/${pack.id}`}
      className="group flex w-full flex-col overflow-hidden rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] transition-shadow hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--co-brand)]"
    >
      <PackArt src={pack.pack_art?.preview_url ?? null} alt="" className="aspect-[3/4] w-full" />
      <div className="flex flex-col gap-0.5 border-t border-[var(--co-border)] p-3">
        <span className="line-clamp-2 text-[13px] font-medium text-[var(--co-text)] group-hover:underline">
          {pack.title}
        </span>
        <span className="font-mono text-[12px] text-[var(--co-muted)]">{formatUsd(pack.price)}</span>
      </div>
    </Link>
  );
}
